export enum LeoAnalysisType {
  DASHBOARD = 'dashboard',
  FLOW = 'flow',
}
